import axiosInstance from "./axiosInstance";

/**
 * Upload an attachment (image or PDF) for a transaction.
 * Returns the public S3 URL.
 *
 * The backend handles multipart parsing + S3 PutObject. Don't set
 * Content-Type header manually — the browser auto-sets it with the
 * required multipart boundary when given a FormData body.
 */
export async function uploadAttachment(file) {
  const form = new FormData();
  form.append("file", file);
  const response = await axiosInstance.post("/upload/attachment", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data.url;
}
